module.exports = __webpack_public_path__ + "static/img/3.cf18a558.png";